import React, { useState } from "react";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import PropTypes from 'prop-types';

const SendEmailModal = ({ isOpen, onClose, onSend, tagId }) => {
    const [subject, setSubject] = useState("");
    const [html, setHtml] = useState("");

    const handleSend = () => {
        if (!subject.trim() || !html.trim()) {
            alert("Please provide both subject and content.");
            return;
        }
        onSend({ tagId, subject, html });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            {/* Background overlay */}
            <div className="absolute inset-0 bg-black opacity-50"></div>

            {/* Modal */}
            <div className="bg-white rounded-lg w-full max-w-xl z-50 relative">
                {/* Header */}
                <div className="bg-blue-500 text-white py-3 px-6 rounded-lg w-3/4 mx-auto relative z-10 -mt-6">
                    <h2 className="text-xl font-semibold text-center">Send Email</h2>
                </div>

                <div className="relative bg-white p-6 space-y-6 shadow-md rounded-b-lg overflow-y-auto max-h-[70vh]">
                    <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">Subject</label>
                        <input
                            type="text"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-500"
                        />
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">Email Content</label>
                        <ReactQuill
                            theme="snow"
                            value={html}
                            onChange={setHtml}
                            className="bg-white"
                        />
                    </div>

                    <div className="flex justify-end gap-2">
                        <button
                            onClick={onClose}
                            className="bg-gray-300 text-gray-700 mt-4 px-4 py-2 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSend}
                            className="bg-blue-500 text-white mt-4 px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            Send
                        </button>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default SendEmailModal;

SendEmailModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    tagId: PropTypes.string.isRequired,
    onSend: PropTypes.func.isRequired,
};